// Browser entry point (bundled by scripts/build.mjs into dist/app.js).
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { carryOverLegacyKeys } from "./core/storageKeys";
import { installPopupZoom } from "./core/wheelZoom";

carryOverLegacyKeys();   // v0.5.1: remembered settings move from "dbm-…" to "buildnexx-…" keys (once, before the first render)

installPopupZoom();      // v0.7.1: Ctrl + wheel in a pop-up zooms the pop-up, not the browser (core/wheelZoom.ts)

createRoot(document.getElementById("root")!).render(<App />);
